export class QuoteRequest {
    constructor(RequestorId = "", Id = "", External1035 = 0, AgeUseCode = "", DateOfBirth = new Date(), SolveType = "", State = "", Age = "", Gender = "", Premium = "", FaceAmount = "") {
        this.RequestorId = RequestorId;
        this.Id = Id;
        this.External1035 = External1035;
        this.AgeUseCode = AgeUseCode;
        this.DateOfBirth = DateOfBirth;
        this.SolveType = SolveType;
        this.State = State;
        this.Age = Age;
        this.Gender = Gender;
        this.Premium = Premium;
        this.FaceAmount = FaceAmount;
    }
}
